const udhrPreamble = `Visto que la llibertá, la xusticia y la paz en mundu sofítense na reconocencia de la dignidá intrínseca y de los drechos iguales y inayenables de tolos miembros que formen la familia humana;

Visto que desconocer o facer de menos los drechos humanos foi la causa d'actos xabaces y dañibles pa la conciencia de la humanidá, y que se proclamó, comu aspiración cimera del home, el llogru d'un mundu onde los seres humanos, llibres del mieu y de la llaceria, gocen de la llibertá de palabra y de la llibertá de creyencies;

Visto que ye esencial un réxime de Drechu que protexa los drechos humanos, p'asina nun se ver emburriáu l'home al recursu caberu de rebelase escontra de la tiranía y de la opresión;

Visto que ye tamién esencial promover l'afitamientu de rellaciones amistoses ente les naciones;

Visto que los pueblos dexaron llantáu na Carta de les Naciones Xuníes el so enfotu nos drechos fundamentales del home, na dignidá y nel valor de la persona humana y na igualdá de drechos d'homes y muyeres, amosando la clara intención de promover el progresu social y de facer espoxigar el nivel de vida según un conceutu más ampliu de la llibertá;

Visto que los Estaos Miembros comprometiéronse a asegurar, en comuña cola Organización de les Naciones Xuníes, el respetu universal y efeutivu a los drechos y llibertaes fundamentales del home; y

Considerando qu'una conceición común d'estos drechos y llibertaes ye bramente importante a fin de percumplir el dichu compromisu;`;

const udhr1 = `Tolos seres humanos nacen llibres y iguales en dignidá y drechos y, pola mor de la razón y la conciencia de so, han comportase hermaniblemente los unos colos otros.`;

module.exports = {
    name: "Asturian",
    udhrPreamble,
    udhr1,
    lang: 'ast',
}